"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Numbers_1 = require("../../Utility/Numbers");
HTMLInputElement.prototype.tryParseInt = function tryParseInt(defaultsTo) {
    return Numbers_1.default.tryParseInt(this.value, defaultsTo !== null && defaultsTo !== void 0 ? defaultsTo : 0);
};
HTMLInputElement.prototype.parseInt = function parseInt() {
    return Numbers_1.default.parseInt(this.value);
};
//# sourceMappingURL=ParseInt.js.map